import _toConsumableArray from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { css } from "styled-components";
import applyGap from "./applyGap";
import lengthOf from "./lengthOf";
import realCellsCount from "./realCellsCount";
import calculateColumnPlacement from "./calculateColumnPlacement";
import calculateRowPlacement from "./calculateRowPlacement";
/*
  This functions is applying a proper -ms-grid-column and -ms-grid-row
  as IE10+ can't resolve auto placement by itself natively
 */

var autoPlacement = function autoPlacement(childrenCount, columns, rows, columnGap, rowGap) {
  var columnsCount = realCellsCount(!!columnGap, lengthOf(columns));
  var rowsCount = realCellsCount(!!rowGap, lengthOf(rows));
  return Array.apply(void 0, _toConsumableArray(Array(childrenCount))).map(function (_, i) {
    var index = i + 1;
    var columnIndex = calculateColumnPlacement(index, columnsCount);
    var rowIndex = calculateRowPlacement(index, columnsCount, rowsCount);
    return css(["& > *:nth-child(", "){-ms-grid-column:", ";-ms-grid-row:", ";}"], index, applyGap(columnIndex, !!columnGap), applyGap(rowIndex, !!rowGap));
  });
};

export default autoPlacement;